var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Common',{attrs:{"title":"USERS","key-expr":"usr_uuid","data-source":_vm.users,"allow-updating":true,"allow-adding":true,"allow-deleting":true,"columns":_vm.columns},on:{"saving":_vm.onSaving}})}
var staticRenderFns = []

export { render, staticRenderFns }